import { render } from "./teaStudioList.vue?vue&type=template&id=3ac4475e&scoped=true"
import script from "./teaStudioList.vue?vue&type=script&lang=js"
export * from "./teaStudioList.vue?vue&type=script&lang=js"

import "./teaStudioList.vue?vue&type=style&index=0&id=3ac4475e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac4475e"]])

export default __exports__